export const NUTRIENT_COMPOSITION = {
  ALL: 1,
  PARTIAL: 0,
} as const;
